import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { Settings } from '@/modules/education/v1/api/v1/settings/Dto/Settings'

/** GET /api/education/v1/settings: настройки пользователя или значения по умолчанию узла */
export class GetSettingsRoute extends EducationRoute<null, Settings> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/education/v1/settings'
  }

  offline(): Promise<ApiResponse<Settings>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new Settings({ period: 1800, size: 15 }) }))
  }
}
